<template>
  <v-container fluid grid-list-md>
    <!--Dialog para confirmação de exclusão-->
    <p-confirm :text="'Os participantes que possuem esse acesso serão alterados para o acesso ' + this.deleteRedirectItem() + ', tem certeza que deseja excluir o item de Acesso'" entity="none" :dialog="dialogConfirm" @confirm="deleteItem(`?newAccess=${items[deleteRedirectIndex()].id}`)" @cancel="closeDialogDelete"></p-confirm>
    <!--Index-->
    <v-layout v-if="!dialog" wrap justify-center align-center>
      <v-flex xs12 sm8>
        <span class="headline"><v-icon large class="mr-1" color="primary">{{this.translate('table.accesses.icon')}}</v-icon>{{ this.translate('system.title.consult') + this.translate('table.' + this.entity + '.title')[0] }}</span>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field id="access_search" append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :no-data-text="emptyTable"
          rows-per-page-text="Registros por página"
          :rows-per-page-items="[25,50,100,{'text':'Todos','value':-1}]"
          :headers="headers"
          :items="items"
          :search="search"
          class="elevation-1"
          :custom-filter="customizedFilter" style="word-break: break-all;">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.id_text }}</td>
            <td>{{ props.item.description ? props.item.description : '' }}</td>
            <td align="center">
              <v-tooltip bottom>
                <v-btn :id="'access_edit_btn_'+props.index" slot="activator" icon class="mx-0" @click="editAccess(props.item)" :disabled="!checkPermission(entity, 'edit')">
                  <v-icon color="teal">edit</v-icon>
                </v-btn>
                <span>{{ editTooltipText }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn :id="'access_delete_btn_'+props.index" slot="activator" icon class="mx-0" @click="dialogDelete(props.item)" :disabled="!checkPermission(entity, 'delete')">
                  <v-icon color="pink">delete</v-icon>
                </v-btn>
                <span>{{ deleteTooltipText }}</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!--Create Edit-->
    <v-form v-else v-model="valid" @keyup.native.ctrl.enter="save()" ref="form">
      <v-layout wrap justify-center align-center>
        <v-flex xs12>
          <span class="headline">{{ formTitle }}</span>
        </v-flex>
        <v-flex xs12 md6>
            <v-text-field id="access_id_text" maxlength="190" counter="190" ref="autofocus" :label="translate('table.' + entity + '.field.id_text')" type="text" v-model="editedItem.id_text"
                          :rules="existRule(translate('table.' + entity + '.field.id_text'),'id_text')"/>
        </v-flex>
        <v-flex xs12 md6>
          <v-text-field id="access_description" name="description" :label="translate('table.' + entity + '.field.description')" type="text"
                        v-model="editedItem.description" />
        </v-flex>
        <v-flex xs12 sm9>
          <span class="headline">{{this.translate('table.permissions.title')[1]}}</span>
        </v-flex>
        <v-flex xs12 sm3>
          <v-text-field id="access_permission_search" append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
        </v-flex>
        <v-flex xs12>
        <v-tabs dark color="cyan" v-model="tab" grow class="elevation-1">
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab key="0">{{this.translate('system.accesses.modules')}}</v-tab>
          <v-tab key="1">{{this.translate('system.accesses.analytic')}}</v-tab>
          <v-tabs-items v-model="tab" touchless>
            <v-tab-item key="0">
              <v-card>
                <v-data-table
                  rows-per-page-text="Registros por página"
                  :rows-per-page-items="[25,50,100,{'text':'Todos','value':-1}]"
                  :headers="headers_permissions_module"
                  :items="permissions.filter(val => {return val.type==='module'})"
                  class="elevation-1">
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.title }}</td>
                    <td>
                      <v-layout justify-center>
                        <v-checkbox primary hide-details v-model="props.item.view" :disabled="props.item.view === 'disabled'"/>
                      </v-layout>
                    </td>
                    <td>
                      <v-layout justify-center>
                        <v-checkbox primary hide-details v-model="props.item.create"/>
                      </v-layout>
                    </td>
                    <td>
                      <v-layout justify-center>
                        <v-checkbox primary hide-details v-model="props.item.edit"/>
                      </v-layout>
                    </td>
                    <td>
                      <v-layout justify-center>
                        <v-checkbox primary hide-details v-model="props.item.delete"/>
                      </v-layout>
                    </td>
                    <td>
                      <v-layout justify-center>
                        <v-checkbox primary hide-details v-model="props.item.manage" :disabled="props.item.manage === 'disabled'" :indeterminate="props.item.manage === 'disabled'"/>
                      </v-layout>
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
            <v-tab-item key="1">
              <v-card>
                <v-card-text>
                  <v-data-table
                    rows-per-page-text="Registros por página"
                    :rows-per-page-items="[25,50,100,{'text':'Todos','value':-1}]"
                    :headers="headers_permissions_analytic"
                    :items="permissions.filter(val => {return val.type!=='module'})"
                    class="elevation-1">
                    <template slot="items" slot-scope="props">
                  <td>{{ props.item.title }}</td>
                      <td>
                        <v-checkbox primary hide-details v-model="props.item.view" :disabled="props.item.view === 'disabled'"/>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-tab-item>
            </v-tabs-items>
        </v-tabs>
        </v-flex>
      </v-layout>
    </v-form>

    <v-layout v-if="view === 1"  class="fab-container" align-center>
      <v-tooltip top>
        <v-btn id="access_add_btn" slot="activator" color="primary" fab @click="createAccess" :disabled="!checkPermission(entity, 'create')">
          <v-icon>{{this.translate('system.button.add.icon')}}</v-icon>
        </v-btn>
        <span>{{createTooltipText}}</span>
      </v-tooltip>
    </v-layout>

    <v-layout v-else class="fab-container" align-center>
      <v-speed-dial v-if="view === 2" v-model="fab" open-on-hover>
        <v-tooltip left slot="activator">
          <v-btn id="access_save_btn" v-model="fab" slot="activator" fab color="primary" :loading="loading" dark @click="save()">
            <v-icon>{{this.translate('system.button.save.icon')}}</v-icon>
            <v-icon>{{this.translate('system.button.done.icon')}}</v-icon>
          </v-btn>
          <span>{{this.translate('system.button.save.title')}}</span>
        </v-tooltip>

        <v-tooltip left>
          <v-btn id="access_save_new_btn" slot="activator" fab small color="secondary" :loading="loading" @click="saveNew()">
            <v-icon>{{this.translate('system.button.save_new.icon')}}</v-icon>
          </v-btn>
          <span>{{this.translate('system.button.save_new.title')}}</span>
        </v-tooltip>

      </v-speed-dial>

      <v-tooltip top>
        <v-btn id="access_done_btn" slot="activator" v-if="view === 3" color="primary" :loading="loading" dark fab @click="save()">
          <v-icon>{{this.translate('system.button.done.icon')}}</v-icon>
        </v-btn>
        <span>{{this.translate('system.button.done.title')}}</span>
      </v-tooltip>

      <v-tooltip top>
        <v-btn id="access_close_btn" slot="activator" fab small @click="close">
          <v-icon>{{this.translate('system.button.close.icon')}}</v-icon>
        </v-btn>
        <span>{{this.translate('system.button.close.title')}}</span>
      </v-tooltip>
    </v-layout>
  </v-container>
</template>

<style scoped>
  tr td:last-child {
    min-width: 130px;
  }

  .fab-container {
    position: fixed;
    bottom: 16px;
    right: 16px;
    z-index: 4;
  }
</style>

<script>
  import socket from '../mixin/socket'
  import crud from '../mixin/crud'
  import access from '../mixin/access'
  import rules from '../mixin/rules'
  import tooltip from '../mixin/tooltip'
  import PConfirm from './shared/PConfirm'

  export default {
    mixins: [crud, access, rules, socket, tooltip],
    components: {
      PConfirm
    },
    data: () => ({
      access: {
        id_text: '',
        description: ''
      },
      tab: null,
      permissions: {},
      entity: 'accesses',
      fab: null,
      access_id: '',
      search: '',
      search_permissions: '',
      delRedir: null
    }),
    created () {
      this.$socket.emit('joinRoom', {room: this.socketRoom}) // Coloca o usuário na sala referente aos acessos para receber os eventos corretos
      this.$store.commit('loader/change_dialog', true)
      this.editedItem = {permissions: '', id_text: '', description: ''}
      this.defaultItem = {permissions: '', id_text: '', description: ''}
      this.initialize()
    },
    methods: {
      initialize () {
        this.$http.get(`api/${this.entity}`).then(res => {
          this.items = res.body || []
          // Desabilita o loading
          this.$store.commit('loader/change_dialog', false)
        })
      },
      beforeInsert () {
        this.editedItem.permissions = JSON.stringify(this.permissions)
      },
      afterInsert (newValues) {
        this.$socket.emit('generalEvent', {
          data: newValues,
          responseEvent: 'addSocketItem',
          room: this.socketRoom
        })
      },
      deleteRedirectIndex () {
        let index = this.items.indexOf(this.editedItem)
        return (index + 1) % this.items.length
      },
      deleteRedirectItem () {
        if (this.items.length < 2) {
          return ''
        }
        return this.items[this.deleteRedirectIndex()].id_text
      },
      beforeUpdate () {
        this.editedItem.permissions = JSON.stringify(this.permissions)
        // foi incluido o access_id para guarda o id do accesso editado para ser comparado no afterUpdate
        this.access_id = this.editedItem.id
      },
      beforeDelete (oldValues) {
        if (this.items.length < 2) {
          this.$store.commit('snackbar/change_values', {
            text: `Não foi possivel excluir este Acesso, é necessario pelo menos um Acesso`, color: 'error', dialog: true, timeout: 7000
          })
          return false
        }
        this.delRedir = this.items[this.deleteRedirectIndex()]
        // socket com objetivo de envio para mudar permições dos usuarios que perderam sua permissão
      },
      afterUpdate (newValues, oldValues) {
        newValues.users.forEach((val) => {
          this.$socket.emit('generalEvent', {
            data: newValues,
            notBroadcast: true,
            responseEvent: 'changePermissions',
            room: `user${val}`
          })
        })
        this.$socket.emit('generalEvent', {
          data: newValues,
          responseEvent: 'editSocketItem',
          room: this.socketRoom
        })
        // socket para a tela de edição de acesso com objetivo alterar os dados da tela de edição
        this.$socket.emit('generalEvent', {
          data: {values: newValues, entity: 'Acesso'},
          responseEvent: 'editSocketManagementDetails',
          room: `${this.socketRoom}_${oldValues.id}`
        })
        // Modifica o accesso caso seja o mesmo que o usuário possui
        if (this.getterAccess.id === this.access_id) {
          this.editedItem.permissions = this.permissions
          this.$store.commit('access/change_value', this.editedItem)
        }
      },
      afterDelete (oldValues) {
        this.$socket.emit('generalEvent', {
          data: oldValues,
          responseEvent: 'deleteSocketItem',
          room: this.socketRoom
        })
        this.$socket.emit('generalEvent', {
          data: {text: 'Este Acesso foi deletado, por favor recarregue a página para não have conflitos.'},
          responseEvent: 'reloadPageModules',
          room: `${this.socketRoom}_${oldValues.id}`
        })
        if (oldValues.users) {
          oldValues.users.forEach(val => {
            this.$socket.emit('generalEvent', {
              data: this.delRedir,
              notBroadcast: true,
              responseEvent: 'changePermissions',
              room: `user${val}`
            })
          })
          this.$socket.emit('generalDetailsEvent', {
            data: {ids: oldValues.users, access: this.delRedir},
            details: 'users',
            responseEvent: 'editSocketDetailsMany',
            room: `companies${this.$auth.user().company_id}_manage` // * Tela de gerenciamento
          })
        }
      },
      beforeEditAccess (item) {
        this.$socket.emit('joinRoom', {room: `${this.socketRoom}_${item.id}`})
      },
      beforeClose (viewAfterSave) {
        this.$socket.emit('leaveRoom', {room: `${this.socketRoom}_${this.editedItem.id}`})
      },
      editAccess (item) {
        this.beforeEditAccess(item)
        this.permissions = JSON.parse(item.permissions)
        this.editItem(item)
      },
      afterEditSocketManagementDetails (item) {
        this.permissions = JSON.parse(this.editedItem.permissions)
      },
      createAccess () {
        this.create()
        let permissions = this.translate('access')
        this.permissions = permissions.crud.map(val => {
          if (val.type === 'analytic') {
            return {
              id_text: val.id_text,
              title: val.title,
              type: 'analytic',
              view: true
            }
          } else {
            return {
              id_text: val.id_text,
              title: val.title,
              type: 'module',
              view: `${val.id_text === 'companies' ? 'disabled' : true}`,
              create: true,
              edit: true,
              delete: true,
              manage: `${val.id_text === 'accesses' || val.id_text === 'files' ? 'disabled' : true}`
            }
          }
        })
      }
    },
    computed: {
      headers: function () {
        return [
          {text: this.translate(`table.${this.entity}.field.id_text`), value: 'id_text'},
          {text: this.translate(`table.${this.entity}.field.description`), value: 'description'},
          {text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center'}
        ]
      },
      headers_permissions_module: function () {
        return [
          {text: this.translate('table.permissions.field.id_text'), value: 'id_text', width: '70%'},
          {text: this.translate('table.permissions.field.view'), value: 'view', align: 'left'},
          {text: this.translate('table.permissions.field.create'), value: 'create', align: 'left'},
          {text: this.translate('table.permissions.field.edit'), value: 'edit', align: 'left'},
          {text: this.translate('table.permissions.field.delete'), value: 'delete', align: 'left'},
          {text: this.translate('table.permissions.field.manage'), value: 'manage', align: 'left'}
        ]
      },
      headers_permissions_analytic: function () {
        return [
          {text: this.translate('table.permissions.field.id_text'), value: 'id_text', width: '70%'},
          {text: this.translate('table.permissions.field.view'), value: 'view', align: 'left'}
        ]
      }
    },
    destroyed () {
      this.$socket.emit('leaveRoom', {room: this.socketRoom}) // Tira o usuário da sala referente aos acessos pois ele está saindo da tela de acessos
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Access.vue